<template>
  <page-outline :title="pageTitle">
    <template slot="pageContent">
      <b-row class="pb-5 no-gutter">
        <back-button :returnUrl="returnUrl"></back-button>
      </b-row>
      <spinner v-if="activateSpinner"></spinner>
      <!-- <kafka-configuration-form v-else v-model="config" :readonly="!editMode" :mode="mode"></kafka-configuration-form> -->
      <div v-else>
        <b-row>
          <!--WEB SERVICE-->
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="config.name" isMandatory :disabled="!canEdit"
              :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" class="form-group">
            <form-write-group-label-input v-model="config.topic" isMandatory :disabled="!canEdit"
              :inputLabel="$t('common.routing.topic')" :placeholderValue="$t('common.routing.topic')">
            </form-write-group-label-input>
          </b-col>
          <template v-if="!brokersHasPipe">
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="brokersDomain" isMandatory :disabled="!canEdit"
                :inputLabel="$t('common.routing.brokers_domain')" :placeholderValue="$t('common.routing.brokers_domain')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="6" class="form-group">
              <form-write-group-label-input v-model="brokersPort" isMandatory :disabled="!canEdit"
                :inputLabel="$t('common.routing.brokers_port')" :placeholderValue="$t('common.routing.brokers_port')">
              </form-write-group-label-input>
            </b-col>
          </template>
          <template v-for="(broker, index) in brokersArray" v-else>
            <b-col sm="6" class="form-group" :key="'broker-domain-' + index">
              <form-write-group-label-input v-model="broker.domain" @input="changeBroker" isMandatory :disabled="!canEdit"
                :inputLabel="$t('common.routing.brokers_domain')" :placeholderValue="$t('common.routing.brokers_domain')">
              </form-write-group-label-input>
            </b-col>
            <b-col :sm="canEdit ? '5' : '6'" class="form-group" :key="'broker-port-' + index">
              <form-write-group-label-input v-model="broker.port" @input="changeBroker" isMandatory :disabled="!canEdit"
                :inputLabel="$t('common.routing.brokers_port')" :placeholderValue="$t('common.routing.brokers_port')">
              </form-write-group-label-input>
            </b-col>
            <b-col sm="1" class="form-group mt-4 pt-2" :key="'broker-remove-' + index" v-if="canEdit">
              <span><i class="fa fa-minus text-danger pt-2" @click="removeBroker(index)"/></span>
            </b-col>
          </template>
          <b-col sm="1" class="form-group" v-if="canEdit">
            <span @click="addBroker" class="cursor btn btn-tertiary"><i class="fa fa-plus text-success pr-2"/>{{ $t('common.routing.add_broker') }}</span>
          </b-col>
        </b-row>
        <form-accordion title="Token credentials" :isTitleUpperCase="false" v-if="login && password">
          <b-row>
            <b-col cols="6" class="fake-hr-right px-0">
              <b-col class="form-group">
                <form-write-group-label-input v-model="loginStorage" :disabled="true" :maxLength="512" inputType="select"
                  :inputLabel="$t('common.routing.loginStorage')">
                  <select autocomplete="off" :aria-label="$t('common.routing.loginStorage')" class="form-control" v-model="loginStorage" :disabled="true">
                    <option value="">{{ $t('common.routing.volume_select') }}</option>
                    <option value="PEM">{{ 'PEM' }}</option>
                    <option value="FILE">{{ 'Volume' }}</option>
                    <option value="Vault">{{ 'Vault' }}</option>
                  </select>
                </form-write-group-label-input>
              </b-col>
              <b-col class="form-group">
                <b-row>
                  <b-col cols="8">
                    <form-write-group-label-input v-model="loginFile" :disabled="true" :maxLength="512"
                      :inputLabel="$t('common.routing.loginFile')" :placeholderValue="$t('common.routing.loginFile')">
                    </form-write-group-label-input>
                  </b-col>
                  <b-col cols="4">
  <span id="login-file-type-label">
    <span aria-hidden="true">Variable</span>
    <span class="sr-only">
      Variable - {{ $t('common.routing.loginFile') }}
    </span>
  </span>

                    <b-form-radio-group
                        id="login-file-type"
                        name="login-file-type"
                        v-model="loginFileType"
                        :disabled="true"
                        aria-labelledby="login-file-type-label">

                      <b-form-radio value="ENV">
                        <span aria-hidden="true">ENV</span>
                        <span class="sr-only">
        {{ $t('common.env_kafka_Client_id_file_location') }}
      </span>
                      </b-form-radio>

                      <b-form-radio value="OTHER">
                        <span aria-hidden="true">{{ $t('common.other') }}</span>
                        <span class="sr-only">
        {{ $t('common.other_kafka_Client_id_file_location') }}
      </span>
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="form-group">
                <b-row>
                  <b-col cols="8">
                    <form-write-group-label-input v-model="loginYAML" :disabled="true" :maxLength="512"
                      :inputLabel="$t('common.routing.loginYAML')" :placeholderValue="$t('common.routing.loginYAML')">
                    </form-write-group-label-input>
                  </b-col>
                  <b-col cols="4">
  <span id="login-yaml-type-label">
    <span aria-hidden="true">Variable</span>
    <span class="sr-only">
      Variable - {{ $t('common.routing.loginYAML') }}
    </span>
  </span>

                    <b-form-radio-group
                        id="login-yaml-type"
                        name="login-yaml-type"
                        v-model="loginYAMLType"
                        :disabled="true"
                        aria-labelledby="login-yaml-type-label">

                      <b-form-radio value="ENV">
                        <span aria-hidden="true">ENV</span>
                        <span class="sr-only">
        {{ $t('common.env_kafka_Client_id_YAML_path') }}
      </span>
                      </b-form-radio>

                      <b-form-radio value="OTHER">
                        <span aria-hidden="true">{{ $t('common.other') }}</span>
                        <span class="sr-only">
        {{ $t('common.other_kafka_Client_id_YAML_path') }}
      </span>
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
              </b-col>

            </b-col>
            <b-col cols="6" class="px-0">
              <b-col class="form-group">
                <form-write-group-label-input v-model="passwordStorage" :disabled="true" :maxLength="512" inputType="select"
                  :inputLabel="$t('common.routing.passwordStorage')">
                  <select autocomplete="off" :aria-label="$t('common.routing.passwordStorage')" class="form-control" v-model="loginStorage" :disabled="true">
                    <option value="">{{ $t('common.routing.volume_select') }}...</option>
                    <option value="PEM">{{ 'PEM' }}</option>
                    <option value="FILE">{{ 'Volume' }}</option>
                    <option value="Vault">{{ 'Vault' }}</option>
                  </select>
                </form-write-group-label-input>
              </b-col>
              <b-col class="form-group">
                <b-row>
                  <b-col cols="8">
                    <form-write-group-label-input v-model="passwordFile" :disabled="true" :maxLength="512"
                      :inputLabel="$t('common.routing.passwordFile')" :placeholderValue="$t('common.routing.passwordFile')">
                    </form-write-group-label-input>
                  </b-col>
                  <b-col cols="4">
  <span id="password-file-type-label">
    <span aria-hidden="true">Variable</span>
    <span class="sr-only">
      Variable - {{ $t('common.routing.passwordFile') }}
    </span>
  </span>

                    <b-form-radio-group
                        id="password-file-type"
                        name="password-file-type"
                        v-model="passwordFileType"
                        :disabled="true"
                        aria-labelledby="password-file-type-label">

                      <b-form-radio value="ENV">
                        <span aria-hidden="true">ENV</span>
                        <span class="sr-only">
        {{ $t('common.env_kafka_Client_password_file_location') }}
      </span>
                      </b-form-radio>

                      <b-form-radio value="OTHER">
                        <span aria-hidden="true">{{ $t('common.other') }}</span>
                        <span class="sr-only">
        {{ $t('common.other_kafka_Client_password_file_location') }}
      </span>
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col class="form-group">
                <b-row>
                  <b-col cols="8">
                    <form-write-group-label-input v-model="passwordYAML" :disabled="true" :maxLength="512"
                      :inputLabel="$t('common.routing.passwordYAML')" :placeholderValue="$t('common.routing.passwordYAML')">
                    </form-write-group-label-input>
                  </b-col>
                  <b-col cols="4">
  <span id="password-yaml-type-label">
    <span aria-hidden="true">Variable</span>
    <span class="sr-only">
      Variable - {{ $t('common.routing.passwordYAML') }}
    </span>
  </span>

                    <b-form-radio-group
                        id="password-yaml-type"
                        name="password-yaml-type"
                        v-model="passwordYAMLType"
                        :disabled="true"
                        aria-labelledby="password-yaml-type-label">

                      <b-form-radio value="ENV">
                        <span aria-hidden="true">ENV</span>
                        <span class="sr-only">
        {{ $t('common.env_kafka_Client_password_YAML_path') }}
      </span>
                      </b-form-radio>

                      <b-form-radio value="OTHER">
                        <span aria-hidden="true">{{ $t('common.other') }}</span>
                        <span class="sr-only">
        {{ $t('common.other_kafka_Client_password_YAML_path') }}
      </span>
                      </b-form-radio>
                    </b-form-radio-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-col>
          </b-row>
        </form-accordion>
      </div>
      <b-row class="justify-content-end mt-3 no-gutters">
        <b-button v-if="mode === 'create'"
        @click="createConfig" variant="primary">
          <i class="fa-light fa-save"></i>
          <span>{{$t('common.sve')}}</span>
        </b-button>
        <b-button class="mr-3" v-if="mode === 'details' && editMode === false && canEditConfig"
        @click="editModeActivate" variant="primary">
          <span>{{$t('common.routing.edit_this_config')}}</span>
        </b-button>
        <b-button class="mr-3" v-if="mode === 'details' && editMode === false && canDeleteConfig"
        @click="deleteConfig" variant="primary">
          <i class="fa-light fa-trash"></i>
          <span>{{$t('common.routing.delete_config')}}</span>
        </b-button>
        <b-button variant="primary" v-if="mode === 'details' && editMode === true"
          @click="editConfig">
          <i class="fa-light fa-save"></i>
          <span>{{ $t('common.sve') }}</span>
        </b-button>
      </b-row>
    </template>
  </page-outline>
</template>

<script>

import _ from 'lodash'

import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from '@/helpers/alert'
import backButton from "@/components/common/backButton.vue"
import Spinner from '@/components/common/spinner.vue'

import {loadPage} from '@/helpers/routing'


export default {
  name: 'KafkaConfigurationDetails',
  components: {
    'back-button': backButton,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  props: {
    mode: {
      type: String,
      default: "create"
    }
  },
  data () {
    return {
      activateSpinner: false,
      config: {
        name: '',
        brokers: '',
        topic: '',
        login: '',
        password: ''
      },
      brokersArray: [],
      editMode: false,
      returnUrl: '/routing/configurationList/KAFKA',
      savedConfig: []
    }
  },
  computed: {
    canDeleteConfig () {
      return this.$engine.rights.rightIs('kafkaConfig_supprimer', true)
    },
    canEditConfig () {
      return this.$engine.rights.rightIs('kafkaConfig_editer', true)
    },
    brokersDomain: {
      get () {
        return this.brokersArray?.[0]?.domain
      },
      set (val) {
        this.brokersArray[0].domain = val
        this.config.brokers = val + ':' + this.config.brokers?.split(',')?.[0]?.split(':')?.[1]
      }
    },
    brokersPort: {
      get () {
        return this.brokersArray?.[0]?.port
      },
      set (val) {
        this.brokersArray[0].port = val
        this.config.brokers = this.config.brokers?.split(',')?.[0]?.split(':')?.[0] + ':' + val
      }
    },
    brokersHasPipe() {
      return this?.config?.brokers?.includes(',')
    },
    canEdit() {
      return this.editMode
    },
    login: {
      get () {
        return this.config.login
      },
      set (val) {
        this.config = {
          name: this.config.name,
          brokers: this.config.brokers,
          topic: this.config.topic,
          login: val,
          password: this.config.password
        }
      }
    },
    loginStorage: {
      get () {
        let storageMatch = this.config.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return storageMatch && storageMatch.length > 1 ? storageMatch[1] : ''
      }
    },
    loginFile: {
      get () {
        let envMatch = this.config.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 3 ? envMatch[3] : ''
      }
    },
    loginFileType: {
      get () {
        let envMatch = this.config.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 2 ? envMatch[2] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    loginYAML: {
      get () {
        let envMatch = this.config.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 5 ? envMatch[5] : ''
      }
    },
    loginYAMLType: {
      get () {
        let envMatch = this.config.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 4 ? envMatch[4] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    password: {
      get () {
        return this.config.password
      },
      set (val) {
        this.config = {
          name: this.config.name,
          brokers: this.config.brokers,
          topic: this.config.topic,
          login: this.config.login,
          password: val
        }
      }
    },
    passwordStorage: {
      get () {
        let storageMatch = this.config.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return storageMatch && storageMatch.length > 1 ? storageMatch[1] : ''
      }
    },
    passwordFile: {
      get () {
        let envMatch = this.config.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 3 ? envMatch[3] : ''
      }
    },
    passwordFileType: {
      get () {
        let envMatch = this.config.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 2 ? envMatch[2] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    passwordYAML: {
      get () {
        let envMatch = this.config.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 5 ? envMatch[5] : ''
      }
    },
    passwordYAMLType: {
      get () {
        let envMatch = this.config.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 4 ? envMatch[4] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    pageTitle () {
      return this.mode === "details" ? this.$t('Webheader.kafka_details') : this.$t('Webheader.kafka_add')
    },
  },
  created () {
    this.activateSpinner = true
    if (this.mode === "details") {
      let that = this
      this.activateSpinner = true
      this.$engine.routing.config.kafka.fetch({idConfigKafka: this.$engine.routing.config.clickedConfig.idConfigKafka})
      .then(resp => {
        if (resp.data && resp.data.configKafka && resp.data.configKafka.length) {
          that.savedConfig = resp.data.configKafka[0]
          that.config = resp.data.configKafka[0]
          that.config = {
            brokers : that.config.brokers,
            topic : that.config.topic,
            name : that.config.name,
            login : that.config.Login,
            password : that.config.Password
          }
          that.brokersArray = that.config.brokers.split(',').map((broker) => {
            let split = broker ? broker.split(':') : []
            return {
              domain: split.length ? split[0] : '',
              port: split.length > 1 ? split[1] : ''
            }
          })
        }
        this.activateSpinner = false
      })
      .catch(err => {
        errorMessageAlert(err, that)
      })
      this.fillFields()
      this.$engine.routing.config.clickedConfig = {}
    } else {
      this.editMode = true
    }

    this.$f7.initPullToRefresh()
    this.activateSpinner = false
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
    addBroker () {
      this.brokersArray.push({
        domain: '',
        port: ''
      })
      this.config.brokers += ','
      this.brokersArray = _.cloneDeep(this.brokersArray)
    },
    changeBroker () {
      console.log('brokers', this.config.brokers)
      this.config.brokers = this.brokersArray.map(elem => elem.domain + ':' + elem.port).join(',')
      console.log('brokers', this.config.brokers)
    },
    changeUri () {
      this.brokersDomain = this.domainPathArray.join(',')
    },
    createConfig () {

    },
    editConfig () {
      let that = this

      if (this.formHasError()) {
        return
      }

      let params = {
        idConfigKafka: this.savedConfig.idConfigKafka,
        name: this.config.name,
        brokers: this.config.brokers,
        topic: this.config.topic
      }
      this.$engine.routing.config.kafka.edit(params)
      .then(() => {
        that.$f7.modal({
          title: this.$t('common.routing.config_edited'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
        loadPage(that, {url: '/routing/configurationList/KAFKA'})
      })
      .catch(e => {
        errorMessageAlert(e, that)
        this.okMessageBox(this.$t('common.routing.config_edition_error'))
      })
    },
    editModeActivate () {
      this.editMode = true
    },
    fillFields () {
      this.config.name = this.savedConfig.Name
      this.config.brokers = this.savedConfig.brokers
      this.config.topic = this.savedConfig.topic
      this.config.sslActive = this.savedConfig.SSLMode
      this.config.login = this.savedConfig.Login
      this.config.password = this.savedConfig.Password
    },
    formHasError () {
      if (this.config.name === undefined || this.config.name.length === 0) {
        this.okMessageBox(this.$t('common.routing.config_name_missing'))
        return true
      }
      if (this.config.brokers === undefined || this.config.brokers.length === 0) {
        this.okMessageBox(this.$t('common.routing.brokers_missing'))
        return true
      } else {
        let brokersError = false
        this.brokersArray.forEach(item => {
          if (!item.domain || !item.port) {
            brokersError = true
          }
        })
        if (brokersError) {
          this.okMessageBox(this.$t('common.routing.brokers_missing'))
          return true
        }
      }
      if (this.config.topic === undefined || this.config.topic.length === 0) {
        this.okMessageBox(this.$t('common.routing.topic_missing'))
        return true
      }
      return false
    },
    goBack () {
      if (this.editMode === true) {
        this.editMode = false
        this.fillFields()
      }
      else {
        loadPage(this, {url: '/routing/configurationList/KAFKA'})
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    removeBroker (index) {
      console.log('remove index', index, 'amongst', this.brokersArray.length, 'indexes')
      this.brokersArray = this.brokersArray.filter((_, i) => i !== index)
      console.log('this.brokersArray', this.brokersArray)
      this.config.brokers = this.brokersArray.map(elem => {
        let brokerJoint = elem.domain + ':' + elem.port
        return brokerJoint === ':' ? '' : brokerJoint
      }).join(',')
    }
  }
}
</script>
